import { z } from 'zod';

/**
 * Domain primitives shared across the client and Edge Functions.
 * These enums mirror the PostgreSQL enum types defined in the migrations —
 * keep the two in sync (the DB is the source of truth; these validate at the edge).
 */

/** Assignable roles, in descending privilege order (drives admin role pickers). */
export const USER_ROLES = ['admin', 'writer', 'reader'] as const;
export const userRoleSchema = z.enum(USER_ROLES);
export type UserRole = z.infer<typeof userRoleSchema>;

export const articleStatusSchema = z.enum(['draft', 'pending', 'published', 'rejected']);
export type ArticleStatus = z.infer<typeof articleStatusSchema>;

export const reactionTypeSchema = z.enum(['useful', 'eye', 'share', 'confused']);
export type ReactionType = z.infer<typeof reactionTypeSchema>;

export const subscriberStatusSchema = z.enum(['pending', 'confirmed', 'unsubscribed']);
export type SubscriberStatus = z.infer<typeof subscriberStatusSchema>;

export const inviteStatusSchema = z.enum(['pending', 'accepted', 'expired', 'revoked']);
export type InviteStatus = z.infer<typeof inviteStatusSchema>;

export const ARTICLE_CATEGORIES = [
  'Basics',
  'Fraud',
  'Controls',
  'Investigations',
  'Compliance',
  'Technology',
  'Risk',
  'Governance',
] as const;
export const articleCategorySchema = z.enum(ARTICLE_CATEGORIES);
export type ArticleCategory = z.infer<typeof articleCategorySchema>;

/** Avatar palette — matches the Tailwind classes used by the UI. */
export const AVATAR_COLORS = [
  'bg-amber-500',
  'bg-sky-500',
  'bg-violet-500',
  'bg-emerald-500',
  'bg-rose-500',
  'bg-indigo-500',
  'bg-teal-500',
  'bg-orange-500',
] as const;
export const avatarColorSchema = z.enum(AVATAR_COLORS);
export type AvatarColor = z.infer<typeof avatarColorSchema>;
